import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { loadScript } from '../../utils';

const BUILD_URL = process.env.REACT_APP_EMBED_QUIZ_V4;

const QuizV4 = ({ uuid }) => {
  useEffect(() => {
    loadScript(BUILD_URL);
    return () => {};
  }, []);

  return (
    uuid && (
      <Container>
        <div style={{ width: '100%', height: '100%' }}>
          <section
            style={{ width: '100%', height: '100%' }}
            id="irobot-embedded-quiz-v4"
            data-experience-id={uuid}
            data-build-url={BUILD_URL}
            data-api-url={`${process.env.REACT_APP_API_BASE_URL}/v4`}
            data-is-qr="true"
          />
        </div>
      </Container>
    )
  );
};

const Container = styled.div`
  height: 100%;
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);
`;

QuizV4.propTypes = {
  uuid: PropTypes.string.isRequired,
};

export default QuizV4;
